<template>

    <trax-ui-ajax-form-hub id="trax-account-user-edit" :endpoint="endpoint" 
         :resource-id="selfEdit ? null : userid" :props="props" :forget="forget" :bus="bus" :toastr-passed-label="1">
    </trax-ui-ajax-form-hub>

</template>

<script>
    export default {
    
        props: {
            userid: null,
            selfEdit: null
        },
        
        data: function() {
            return {
                id: 'trax-account-user-edit',
                endpoint: this.selfEdit ? app_url+"trax/api/front/users/me" : app_url+"polaris/api/front/users",
                props: {
                    username: { source:'username' },
                    email: { source:'email' },
                    firstname: { source:'firstname' },
                    lastname: { source:'lastname' },
                    enac_id: { source:'enac_id' },
                    source: { source:'source' },
                    admin: { source:'admin' },
                    active: { source:'active' },
                    status: { source:'meta.status' },
                    entity_type: { source:'entity_type' },
                    role_id: { source:'role_id' },
                    entity_id: { source:'entity_id' },
                    subentity_id: { source:'subentity_id' },
                    rights_level: { source:'rights_level' },
                    user_function: { source:'user_function' },
                    occasional_learner: { source:'meta.occasional_learner' },
                    avatar: { source:'avatar' },
                    meta: { source:'meta' }
                },
                forget: [
                    'password',
                    'password_confirmation'
                ],
                bus: this.$bus
            }
        }
    }
</script>
